'use client';
import { useEffect } from 'react';
import { trackPostHogEvent } from '@/lib/analytics/posthog';
export default function TranslationRecoveryTelemetry() {
  useEffect(() => {
    const recovered = (event: Event) => {
      const operation = (event as CustomEvent).detail?.operation;
      if (operation === 'removeChild' || operation === 'insertBefore') {
        trackPostHogEvent('translation_dom_recovered', { operation, evidence: 'observed_text_replaced_by_translator_font' });
      }
    };
    window.addEventListener('pac:translation-recovered', recovered);
    return () => window.removeEventListener('pac:translation-recovered', recovered);
  }, []);
  return null;
}
